export const cropColorsLegendTopFive = [
  "#34D399",
  "#F59E0B",
  "#B36A0C",
  "#A78BFA",
  "#F472B6",
];

export const cropColorsLegend: { [key: string]: string } = {
  "Alfalfa and Alfalfa Mixtures": "#6C63E0", // lighter indigo
  Almonds: "#B36A0C", // warm brown
  Apples: "#F87171", // soft red
  Apricots: "#D97706", // amber
  "Beans (Dry)": "#A5B4FC", // lighter blue
  "Bush Berries": "#635BBD", // softer violet
  Carrots: "#DC2626", // brighter red
  Cherries: "#F43F5E", // rose
  Citrus: "#F59E0B", // orange
  "Cole Crops": "#8B5E3C", // earthy brown
  "Corn, Sorghum and Sudan": "#D97706", // amber
  Cotton: "#A68F44", // muted yellow brown
  Grapes: "#A78BFA", // lavender
  Kiwi: "#60A5FA", // soft blue
  "Lettuce/Leafy Greens": "#10B981", // emerald
  "Melons, Squash and Cucumbers": "#14B8A6", // teal
  "Miscellaneous Deciduous": "#A78BFA", // lavender
  "Miscellaneous Field Crops": "#6B7280", // gray
  "Miscellaneous Grain and Hay": "#3B82F6", // blue
  "Miscellaneous Grasses": "#059669", // green
  "Miscellaneous Subtropical Fruits": "#B45309", // bronze
  "Miscellaneous Truck Crops": "#D946EF", // fuchsia
  "Mixed Pasture": "#EC4899", // pink
  Olives: "#22C55E", // green
  "Onions and Garlic": "#9333EA", // violet
  "Peaches/Nectarines": "#F472B6", // light pink
  Pears: "#F43F5E", // rose
  Pecans: "#B45309", // brown
  Peppers: "#EF4444", // red
  Pistachios: "#34D399", // mint green
  Plums: "#9F1239", // plum red
  Pomegranates: "#D97706", // orange
  Potatoes: "#38BDF8", // cyan-blue
  Prunes: "#A855F7", // purple
  Rice: "#2DD4BF", // aqua
  Safflower: "#F97316", // bright orange
  Strawberries: "#EF4444", // red
  Sunflower: "#CA8A04", // goldenrod
  "Sweet Potatoes": "#C2410C", // dark orange
  Tomatoes: "#DC2626", // strong red
  Turf: "#4ADE80", // spring green
  "Unclassified Fallow": "#FBBF24", // yellow
  Walnuts: "#65A30D", // moss green
  Wheat: "#9CA3AF", // light gray
  "Sugar Beets": "#4B5563", // soft slate
};
